import { FC } from 'react';

import { AdvancedDateFilter } from './AdvancedDateFilter';
import { CurrencyFilter } from './CurrencyFilter';

export interface AdvancedFiltersProps {
  currencyFilter?: string;
  startDate?: string;
  endDate?: string;
  onCurrencyFilterChanged(event: string): void;
  onStartDateFilterChanged(date: Nullable<string>): void;
  onEndDateFilterChanged(date: Nullable<string>): void;
}

export const AdvancedFilters: FC<AdvancedFiltersProps> = ({
  currencyFilter,
  onCurrencyFilterChanged,
  startDate,
  onStartDateFilterChanged,
  endDate,
  onEndDateFilterChanged,
}) => {
  return (
    <div className="w-100 d-flex flex-row justify-content-end border-top">
      <CurrencyFilter onCurrencyFilterChanged={onCurrencyFilterChanged} currencyFilter={currencyFilter} />
      <AdvancedDateFilter
        startDate={startDate}
        onStartDateFilterChanged={onStartDateFilterChanged}
        endDate={endDate}
        onEndDateFilterChanged={onEndDateFilterChanged}
      />
    </div>
  );
};
